// Shared Header — self-fetching shortlist variant (most pages)
// Fetches CSRF token + shortlist summary on load. No external interaction needed.

import { initMenuControllers, initTrustElements, ShortlistUIUpdater } from './shared-header-core';
import type { ShortlistSummary } from './shared-header-core';

const CSRF_URL = `${process.env.SITE_URL}/results/vto/search/csrf/token`;
const SHORTLIST_URL = `${process.env.SITE_URL}/results/vto/search/shortlists`;

async function fetchShortlist(updater: ShortlistUIUpdater): Promise<void> {
  try {
    const csrfResponse = await fetch(CSRF_URL, { credentials: 'include' });
    if (!csrfResponse.ok) return;

    const csrf: { token: string; headerName: string } =
      await csrfResponse.json();

    const shortlistResponse = await fetch(SHORTLIST_URL, {
      credentials: 'include',
      headers: { [csrf.headerName]: csrf.token },
    });
    if (!shortlistResponse.ok) return;

    const shortlist: ShortlistSummary = await shortlistResponse.json();
    updater.update(shortlist.id, shortlist.accommodationGiataIds.length);
  } catch {
    // Silently fail — badge stays hidden by default
  }
}

function initSharedHeader(): void {
  const headerEl = document.querySelector<HTMLElement>('[data-header]');
  if (!headerEl) return;

  const updater = new ShortlistUIUpdater(headerEl);
  fetchShortlist(updater);

  initMenuControllers(headerEl);
  initTrustElements(headerEl);
}

window.requestIdleCallback(() => {
  setTimeout(() => initSharedHeader(), 0);
});
